const apiUrl = process.env.REACT_APP_API_URL;

/** Actualitza el cron i l'estat (actiu) d'un job. Retorna {ok, message}. */
export const UpdateJobConfig = async (nom: string, cron: string, actiu: number, page: string) => {
    try {
        const params = new URLSearchParams({cron, actiu: String(actiu)});
        const response = await fetch(`${apiUrl}:8072/jobs/config/${nom}?${params.toString()}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const message = await response.text();
        return {ok: response.ok, message};
    } catch (error) {
        console.error('Error actualitzant la configuració del job', error);
        return {ok: false, message: 'Error actualitzant la configuració'};
    }
};
